"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOverflowAmount = void 0;
exports.calculateOverflowAmount = function (legendItemsRef) {
    var overflowAmount;
    if (!legendItemsRef || !legendItemsRef.current) {
        overflowAmount = 0;
    }
    else {
        var currentLegendItems = legendItemsRef.current;
        var offsetTop_1 = currentLegendItems.children[0].offsetTop;
        var children = Array.from(currentLegendItems.children);
        overflowAmount = children.filter(function (d) { return d.offsetTop > offsetTop_1; }).length;
    }
    return overflowAmount;
};
